var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "p-3 mt-2 shadow-sm bg-white" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  staticClass: "text-center text-primary",
                  attrs: { "vs-lg": "1" }
                },
                [
                  _c("div", { class: { "text-success": _vm.wasCopied } }, [
                    _vm._v(" # "),
                    _c("br")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "cursor-pointer",
                      class: { "text-success": _vm.wasCopied },
                      on: {
                        click: function($event) {
                          return _vm.copyToClipboard(_vm.file.id)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.file.id) + " ")]
                  )
                ]
              ),
              _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                _vm._v(" " + _vm._s(_vm.file.theme) + " ")
              ]),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "9" } },
                [
                  _c(
                    "vs-row",
                    [
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "2", "vs-sm": "3", "vs-xs": "12" }
                        },
                        [_vm._v(" " + _vm._s(_vm.file.typeDescription) + " ")]
                      ),
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "2", "vs-sm": "3", "vs-xs": "12" }
                        },
                        [_vm._v(" " + _vm._s(_vm.file.folio) + " ")]
                      ),
                      _vm.$route.params.view === "salientes"
                        ? _c(
                            "vs-col",
                            {
                              staticClass: "px-2",
                              attrs: {
                                "vs-lg": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.withCopyEntity.length > 1
                                      ? "Según distribución"
                                      : _vm.withCopyEntity[0].entidadNombre
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _c(
                            "vs-col",
                            {
                              staticClass: "px-2",
                              attrs: {
                                "vs-lg": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.file.creatorEntityName) + " "
                              )
                            ]
                          ),
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "3", "vs-sm": "3", "vs-xs": "12" }
                        },
                        [_vm._v(" " + _vm._s(_vm.file.createdAt) + " ")]
                      ),
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "2", "vs-sm": "3", "vs-xs": "12" }
                        },
                        [_vm._v(" " + _vm._s(_vm.file.creatorName) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "1",
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center"
          }
        },
        [
          _c("FileOptions", {
            attrs: { file: _vm.file, "select-file": _vm.selectFile },
            on: { "refresh-list": _vm.refreshList }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }